import _extends from "@babel/runtime/helpers/extends";
import '../../css-tokens';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Box from '../Box';
import LabelWrapper from './LabelWrapper';
import PrimaryLabel from './PrimaryLabel';
import OptionalLabel from './OptionalLabel';
import ActionLabel from './ActionLabel';
// import InfoLabel from './InfoLabel';
import styles from './index.module.css';
export { default as getPlacement } from './getPlacement';
const Label = /*#__PURE__*/function () {
  const Label = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      action,
      children,
      className,
      htmlFor,
      id,
      optional,
      width,
      hidden,
      alignItems,
      // info,
      ...rest
    } = _ref;
    return /*#__PURE__*/React.createElement(LabelWrapper, {
      width: width,
      alignItems: alignItems,
      className: cx(className, hidden && styles.hidden)
    }, /*#__PURE__*/React.createElement(PrimaryLabel, _extends({
      as: "label",
      htmlFor: htmlFor,
      id: id,
      ref: ref
    }, rest), /*#__PURE__*/React.createElement(Box, {
      as: "span",
      mr: 1
    }, children), optional && /*#__PURE__*/React.createElement(OptionalLabel, null, optional)), action && /*#__PURE__*/React.createElement(ActionLabel, null, action));
  });
  Label.displayName = 'Label';
  Label.identifier = Label.displayName; // used in docs website
  Label.clonableProps = ['marginProps', 'floatProps'];
  Label.propTypes = {
    /** Contents displayed within the ActionLabel. */
    action: PropTypes.node,
    /** alignItems baseline or center  */
    alignItems: PropTypes.string,
    /** Contents displayed within the PrimaryLabel. */
    children: PropTypes.node.isRequired,
    /** Extend classNames. */
    className: PropTypes.string,
    /** FontWeight atom. */
    fontWeight: PropTypes.oneOf(['inherit', 'regular', 'medium', 'bold']),
    /** Visibly hide the label. */
    hidden: PropTypes.bool,
    /** HTML For attribute, which references to a specific input.  */
    htmlFor: PropTypes.string,
    /** Native HTML id attribute. */
    id: PropTypes.string,
    /** Contents displayed within the OptionalLabel. */
    optional: PropTypes.string,
    /** Width full or auto */
    width: PropTypes.oneOf(['auto', 'full'])
  };
  return Label;
}();
export default Label;